import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ListFilter, X, Undo2 } from 'lucide-react';

export function FilterToggle({ showFilters, setShowFilters, hasActiveFilters }) {
  return (
    <Button
      variant={showFilters ? "default" : "outline"}
      size="sm"
      onClick={() => setShowFilters(!showFilters)}
      className="rounded-sm"
      data-testid="toggle-filters-btn"
    >
      <ListFilter className="w-4 h-4 mr-2" />
      Filters
      {hasActiveFilters && <span className="ml-2 w-2 h-2 rounded-full bg-accent" />}
    </Button>
  );
}

export function FilterPanel({ filters, handleFilterChange, clearFilters, hasActiveFilters }) {
  return (
    <Card className="border rounded-sm shadow-sm animate-fade-in" data-testid="filters-panel">
      <CardContent className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-7 gap-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Year</label>
            <Input
              type="number" placeholder="e.g., 2024" value={filters.year}
              onChange={(e) => handleFilterChange("year", e.target.value)}
              className="rounded-sm" data-testid="filter-year"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Donor Name</label>
            <Input
              placeholder="Search donor..." value={filters.donor}
              onChange={(e) => handleFilterChange("donor", e.target.value)}
              className="rounded-sm" data-testid="filter-donor"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Recipient</label>
            <Input
              placeholder="Search recipient..." value={filters.recipient}
              onChange={(e) => handleFilterChange("recipient", e.target.value)}
              className="rounded-sm" data-testid="filter-recipient"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Address</label>
            <Input
              placeholder="Street address..." value={filters.address}
              onChange={(e) => handleFilterChange("address", e.target.value)}
              className="rounded-sm" data-testid="filter-address"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Min Amount</label>
            <Input
              type="number" placeholder="$0" value={filters.minAmount}
              onChange={(e) => handleFilterChange("minAmount", e.target.value)}
              className="rounded-sm" data-testid="filter-min-amount"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Max Amount</label>
            <Input
              type="number" placeholder="No limit" value={filters.maxAmount}
              onChange={(e) => handleFilterChange("maxAmount", e.target.value)}
              className="rounded-sm" data-testid="filter-max-amount"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground mb-2 block">Type</label>
            <Select
              value={filters.amountType || "all"}
              onValueChange={(v) => handleFilterChange("amountType", v)}
            >
              <SelectTrigger className="rounded-sm" data-testid="filter-amount-type">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all" data-testid="filter-amount-type-all">All contributions</SelectItem>
                <SelectItem value="positive" data-testid="filter-amount-type-positive">Contributions only</SelectItem>
                <SelectItem value="refund" data-testid="filter-amount-type-refund">
                  <span className="flex items-center gap-1.5">
                    <Undo2 className="w-3 h-3 text-amber-600" />
                    Refunds only
                  </span>
                </SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        {hasActiveFilters && (
          <div className="mt-4 pt-4 border-t border-border flex justify-end">
            <Button variant="ghost" size="sm" onClick={clearFilters} className="text-muted-foreground" data-testid="clear-filters-btn">
              <X className="w-3 h-3 mr-1" />
              Clear all filters
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
